<np-register-step2 [accountType]="'partner'"></np-register-step2>
